//API STATUS
export const SUCCESS = 200;
export const BAD_REQUEST = 400;
export const SESSION_EXPIRED = 401;
export const NOT_FOUND = 404;
export const INTERNAL_SERVER_ERROR = 500;
export const POST_SUCCESS = 201;
export const DELETE_SUCCESS = 204;
export const RETCODE_SUCCESS = 0;
export const RETCODE_ERROR = 1;
export const RETCODE_WARING = 2;
export const RETTEXT_SUCCESS = 'Ok';

export const maleColorChart = '#37b9f8';
export const femaleColorChart = '#9727FF';
export const othersColorChart = '#fa886b';

export const activeColorChart = '#00e396';
export const unActiveColorChart = '#37b9f8';
export const discardColorChart = '#fa886b';

// PARAM QUERY
export const PAGE_DEFAULT = 1;
export const LIMIT_DEFAULT = 10;
export const LENGHT_OTP = 6;

// PARAM QUERY

// ROUTES
export const ROUTES = {
  PRODUCT: 'PRODUCT',
  PRODUCT_DETAIL: 'PRODUCT_DETAIL',
  ORDER: 'ORDER',
  SELECT_BRANCH: 'SELECT_BRANCH',
};

//ACTION SHEET
export const CANCEL_INDEX = 0;

export const LIST_ROLES = [
  { value: 'BTC', label: 'CORE:BTC' },
  { value: 'superadmin', label: 'CORE:superadmin' },
];

export const GENDER = [
  { label: 'Nam', value: 'male', key: 'male' },
  { label: 'Nữ', value: 'female', key: 'female' },
  { label: 'Khác', value: 'other', key: 'other' },
];

export const NAMES = [
  { label: 'Anh', value: 'mr', key: 'mr' },
  { label: 'Chị', value: 'miss', key: 'miss' },
];

export const LIST_MONTHS = [
  {
    key: 1,
    value: 'Tháng 1',
    valueEn: 'january',
    month: '01',
  },
  {
    key: 2,
    value: 'Tháng 2',
    valueEn: 'february',
    month: '02',
  },
  {
    key: 3,
    value: 'Tháng 3',
    valueEn: 'march',
    month: '03',
  },
  {
    key: 4,
    value: 'Tháng 4',
    valueEn: 'april',
    month: '04',
  },
  {
    key: 5,
    value: 'Tháng 5',
    valueEn: 'may',
    month: '05',
  },
  {
    key: 6,
    value: 'Tháng 6',
    valueEn: 'june',
    month: '06',
  },
  {
    key: 7,
    value: 'Tháng 7',
    valueEn: 'july',
    month: '07',
  },
  {
    key: 8,
    value: 'Tháng 8',
    valueEn: 'august',
    month: '08',
  },
  {
    key: 9,
    value: 'Tháng 9',
    valueEn: 'september',
    month: '09',
  },
  {
    key: 10,
    value: 'Tháng 10',
    valueEn: 'october',
    month: '10',
  },
  {
    key: 11,
    value: 'Tháng 11',
    valueEn: 'november',
    month: '11',
  },
  {
    key: 12,
    value: 'Tháng 12',
    valueEn: 'december',
    month: '12',
  },
];

export const LIST_PIN_ACTION = [
  { value: 'check-inout', label: 'Điểm danh' },
  { value: 'lucky-draw', label: 'Nhận thưởng' },
];

export const HOT_LINE = '1900 1830';
export const WEBSITE = 'https://matbao.events';
export const PRIVACY_POLICY = 'https://matbao.events/Policy/privacy';

export const VIDEO_ALLOW = 'Allow';
export const VIDEO_DENIED = 'AccessDenied';
export const ORDER_CODE = 'OTHER';

export const TRIAL_CODE = 'TRIAL';
export const OTP_ERROR_CODE = 7;

export const SCREEN_TYPES = {
  JOURNEY_365: 'JOURNEY_365',
  DRAW_SKETCH_NOTE: 'DRAW_SKETCH_NOTE',
  JOURNEY_TO_CONQUER_STAR: 'JOURNEY_TO_CONQUER_STAR',
};

export const FORMAT_TIME = ['mm:ss', 'mmss'];
export const FORMAT_DATE = ['DD/MM/YYYY', 'DD:MM:YYYY', 'DDMMYYYY'];
export const FORMAT_DATETIME = ['DD/MM/YYYY HH:mm', 'DD:MM:YYYY HH:mm', 'DDMMYYYY HHmm'];

export const FORMAT_DATETIME_SINGLE = 'DD/MM/YYYY HH:mm';
export const FORMAT_DATETIME_BIRD_DAY = 'DD/MM/YYYY';
export const DATE_FORMAT = 'DD/MM/YYYY';

export const DEFAULT_QRCODE_IMG_LINK =
  'https://smart-events-pro.s3.ap-southeast-1.amazonaws.com/undelete/qr-code.png';
export const DEFAULT_QRCODE_IMG_LINK_1 =
  'https://smart-events-pro.s3.ap-southeast-1.amazonaws.com/undelete/qr-code-1.png';
export const DEFAULT_QRCODE_IMG_LINK_2 =
  'https://smart-events-pro.s3.ap-southeast-1.amazonaws.com/undelete/qr-code-2.png';
export const DEFAULT_AVATAR_IMG_LINK =
  'https://smart-events-pro.s3.ap-southeast-1.amazonaws.com/undelete/default-avatar.png';

export const DEFAULT_WATER_MARK =
  'https://smart-events-dev.s3.ap-southeast-1.amazonaws.com/undelete/matbao-watermark.png';
export const DEFAULT_INVITATION_LETTER = 'https://events.matbao.ws/thiep-moi';
export const DEFAULT_LOGO_IMG_LINK =
  'https://smart-events-pro.s3.ap-southeast-1.amazonaws.com/undelete/logo_mbws_.png';
export const DEFAULT_IDENTITY_USER = 'https://events.matbao.ws/identity';
export const BTC_DIEM_DANH = 'https://events.matbao.ws/btc-checkin';

// Validate Constants
export const NUMBER_MIN = 0;
export const QUANTITY_MIN = 1;
export const QUANTITY_MAX = 100000000;
export const MAX_PERCENT = 100;
export const INPUT_MAX = 255;
export const TEXTAREA_MAX = 3200;
export const OTHER_TEXTAREA_MAX = 3200;
export const CURRENCY_MIN = 1000;
export const CURRENCY_MAX = 99999999999;
export const COUNT_USE_TICKET = 1000000000;

export const CODE_MIN = 50;

export const OTHER_CODE_MIN = 2;
export const OTHER_CODE_MAX = 10;

export const DEFAULT_CONFIG_REGISTER = {
  groupInviteId: true,
  groupInviteIdRequired: true,
  dateRegister: false,
  dateRegisterRequired: false,
  name: true,
  nameRequired: true,
  gender: false,
  genderRequired: false,
  avatar: true,
  avatarRequired: true,
  _2ndtext: false,
  _2ndtextRequired: false,
  phone: true,
  phoneRequired: true,
  email: true,
  emailRequired: true,
  facebook: false,
  facebookRequired: false,
  socialNetwork: false,
  socialNetworkRequired: false,
  address: false,
  addressRequired: false,
  districtId: false,
  districtIdRequired: false,
  cityId: false,
  cityIdRequired: false,
  dayofbirth: false,
  dayofbirthRequired: false,
  placeOfBirth: false,
  placeOfBirthRequired: false,
  cccd: false,
  cccdRequired: false,
  level: false,
  levelRequired: false,
  status: false,
  statusRequired: false,
  userRegisterId: true,
  userRegisterIdRequired: true,
  codePayment: false,
  codePaymentRequired: false,
};
